module.exports = __webpack_public_path__ + "static/media/Medcare Medical Centre Motor City.3b151148.jpg";